// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicSpotGetV2SystemTime (params?: {}): Promise<Dict>;
    publicSpotGetV2SystemStatus (params?: {}): Promise<Dict>;
    publicSpotGetV2MarketOrderbook (params?: {}): Promise<Dict>;
    publicSpotGetV2MarketTrades (params?: {}): Promise<Dict>;
    publicSpotGetV2MarketTicker (params?: {}): Promise<Dict>;
    publicSpotGetV2MarketAllTickers (params?: {}): Promise<Dict>;
    publicSpotGetV2ExExchangeInfo (params?: {}): Promise<Dict>;
    publicSpotGetV2ExCurrencies (params?: {}): Promise<Dict>;
    publicSpotGetV2MarketKlines (params?: {}): Promise<Dict>;
    publicSpotGetV2ExTradefees (params?: {}): Promise<Dict>;
    publicSwapGetV1SystemTime (params?: {}): Promise<Dict>;
    publicSwapGetV1SystemStatus (params?: {}): Promise<Dict>;
    publicSwapGetV1ExchangeTradefee (params?: {}): Promise<Dict>;
    publicSwapGetV1ExchangeTradefees (params?: {}): Promise<Dict>;
    publicSwapGetV1MarketOrderBook (params?: {}): Promise<Dict>;
    publicSwapGetV1MarketTicker24Hr (params?: {}): Promise<Dict>;
    publicSwapGetV1MarketMarkets (params?: {}): Promise<Dict>;
    publicSwapGetV1MarketAggTrade (params?: {}): Promise<Dict>;
    publicSwapPostV1MarketKlines (params?: {}): Promise<Dict>;
    privateSpotPostV2ExOrders (params?: {}): Promise<Dict>;
    privateSpotGetV2ExOrders (params?: {}): Promise<Dict>;
    privateSpotGetV2AccountBalance (params?: {}): Promise<Dict>;
    privateSpotGetV2ExTradefee (params?: {}): Promise<Dict>;
    privateSpotGetV2ExOrder (params?: {}): Promise<Dict>;
    privateSpotGetV2ExOrderFills (params?: {}): Promise<Dict>;
    privateSpotDeleteV2ExOrder (params?: {}): Promise<Dict>;
    privateSpotDeleteV2ExOrders (params?: {}): Promise<Dict>;
    privateSpotDeleteV2ExOrdersCancelAll (params?: {}): Promise<Dict>;
    privateSwapGetV1WalletBalance (params?: {}): Promise<Dict>;
    privateSwapGetV1TradeOrder (params?: {}): Promise<Dict>;
    privateSwapGetV1TradeOrderOpenOrders (params?: {}): Promise<Dict>;
    privateSwapGetV1TradeUserLeverages (params?: {}): Promise<Dict>;
    privateSwapGetV1TradeUserLeverage (params?: {}): Promise<Dict>;
    privateSwapGetV1TradePositions (params?: {}): Promise<Dict>;
    privateSwapGetV1TradeHistory (params?: {}): Promise<Dict>;
    privateSwapPostV1TradeOrder (params?: {}): Promise<Dict>;
    privateSwapPostV1TradeOrderAddTPSL (params?: {}): Promise<Dict>;
    privateSwapPostV1TradeAddMargin (params?: {}): Promise<Dict>;
    privateSwapPostV1TradeReduceMargin (params?: {}): Promise<Dict>;
    privateSwapPostV1TradePositionClose (params?: {}): Promise<Dict>;
    privateSwapPostV1TradeUpdateUserLeverage (params?: {}): Promise<Dict>;
    privateSwapDeleteV1TradeOrder (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
